export default {
  meta: {
    title: '任务详情'
  }
};
